import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M15.8 8.3a.8.8 0 0 0-1.6 0v.9h-.9a.8.8 0 0 0 0 1.6h.9v.9a.8.8 0 0 0 1.6 0v-.9h.9a.8.8 0 0 0 0-1.6h-.9zM5 6.7c.5 0 .8.3.8.8v4.2a.8.8 0 0 1 0 1.6H4.2a.8.8 0 0 1 0-1.6V8.3a.8.8 0 0 1 0-1.6z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M8.8 6.7c-.7 0-1.3.5-1.3 1.2v.9c0 .4.2.8.6 1-.4.2-.6.6-.6 1v1.3c0 .7.6 1.2 1.3 1.2h1.6c.7 0 1.3-.5 1.3-1.2v-1.3c0-.4-.3-.8-.6-1 .3-.2.6-.6.6-1v-.9c0-.7-.6-1.2-1.3-1.2H8.7ZM10 7.9h-.8v.9h.8zm0 3h-.8v.8h.8v-.9Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "9",
      stroke: "#fff",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }